import { Component, Type } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SidePanelService } from '@lib/services';
import { ApiResponseError, IAuthResponse, IError, IUser } from '@lib/interfaces';
import { IFundTransferResponse } from '@lib/interfaces/transfer.interface';
import { TransferService } from '@lib/services/fund-transfer/transfer.service';
import { BaseComponent } from '@lib/components';
import { finalize } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    template: '',
})
export class SharedPeerToPeerConfirmationComponent extends BaseComponent {
    recipientInfo: IUser; // receiver's info
    userInfo: IAuthResponse['admin']; // sender info
    transferResponse: IFundTransferResponse;
    loading = false;
    redirectToComponent: Type<any>;

    constructor(public dialogRef: MatDialogRef<SharedPeerToPeerConfirmationComponent>, public readonly sidePanel: SidePanelService, private transferService: TransferService, private snackbar: MatSnackBar) {
        super();
    }

    backToPeertoPeer() {
        this.dialogRef.close();
        // this.sidePanel.open(PeerToPeerComponent);
    }

    confirmTransfer() {
        this.loading = true;
        this.addSubscription(
            this.transferService
                .fundTransfer({
                    sender_account_id: this.transferResponse.sender_account_id,
                    recipient_account_id: this.transferResponse.recipient_account_id,
                    amount: this.transferResponse.amount,
                    currency: this.transferResponse.currency,
                    notes: this.transferResponse.notes,
                    dry_run: false,
                })
                .pipe(
                    finalize(() => {
                        this.loading = false;
                    }),
                )
                .subscribe({
                    next: (response: IFundTransferResponse) => {
                        this.dialogRef.close();
                        const dialogRef = this.sidePanel.open(this.redirectToComponent);
                        dialogRef.componentInstance.recipientInfo = this.recipientInfo;
                        dialogRef.componentInstance.userInfo = this.userInfo;
                        dialogRef.componentInstance.transferResponse = response;
                        dialogRef.componentInstance.isMoneySent = true;
                    },
                    error: (error: ApiResponseError) => {
                        this.createApiErrorSnackBar(this.snackbar, error);
                    },
                }),
        );
    }

    rejectTransfer(errorDetails: IError) {
        const dialogRef = this.sidePanel.open(this.redirectToComponent);
        dialogRef.componentInstance.recipientInfo = this.recipientInfo;
        dialogRef.componentInstance.userInfo = this.userInfo;
        dialogRef.componentInstance.transferResponse = this.transferResponse;
        dialogRef.componentInstance.errorDetails = errorDetails;
        dialogRef.componentInstance.isMoneySent = false;
    }
}
